export default "__VITE_ASSET__4d8f9903__"